import { render, staticRenderFns } from "./PopupConfirmationDetail.vue?vue&type=template&id=04da66f3"
import script from "./PopupConfirmationDetail.vue?vue&type=script&lang=js"
export * from "./PopupConfirmationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports